//@author: devin
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Proto } from "../../../pojo/Proto";
import { ModalComponent } from "../modal.component";
import NumericalBoolean = Proto.NumericalBoolean;

@Component({
    template: `
        @if (initModal) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body ngCenter">
                    <div class="ngCenter ngS25ModalDialogMsg" [innerHTML]="data.message | safeHTML"></div>
                    @if (data.showDontShowAgain) {
                        <label class="c-margin-top--single ngS25ModalDialogDontShow">
                            <input
                                type="checkbox"
                                [checked]="data.dontShowAgain"
                                (change)="data.dontShowAgain = $any($event.target).checked"
                            />
                            Don't show this message again
                        </label>
                    }
                </div>
                <div class="modal-footer">
                    <div class="ngCenter ngS25ModalDialogBtn">
                        @if (data.buttonMap.hasYes) {
                            <div class="ngInlineBlock">
                                <button
                                    (click)="yes()"
                                    class="aw-button aw-button--outline"
                                    [class.aw-button--primary]="data.buttonMap.primary === 'Yes'"
                                >
                                    Yes
                                </button>
                            </div>
                        }
                        @if (data.buttonMap.hasContinue) {
                            <div class="ngInlineBlock">
                                <button
                                    (click)="continue()"
                                    class="aw-button aw-button--outline"
                                    [class.aw-button--primary]="data.buttonMap.primary === 'Continue'"
                                >
                                    Continue
                                </button>
                            </div>
                        }
                        @if (data.buttonMap.hasNo) {
                            <div class="ngInlineBlock">
                                <button
                                    (click)="no()"
                                    class="aw-button aw-button--outline"
                                    [class.aw-button--primary]="data.buttonMap.primary === 'No'"
                                >
                                    No
                                </button>
                            </div>
                        }
                        @if (data.buttonMap.hasCancel) {
                            <div class="ngInlineBlock">
                                <button
                                    (click)="cancel()"
                                    class="aw-button aw-button--outline"
                                    [class.aw-button--primary]="data.buttonMap.primary === 'Cancel'"
                                >
                                    Cancel
                                </button>
                            </div>
                        }
                        @if (data.buttonMap.hasOK) {
                            <div class="ngInlineBlock">
                                <button
                                    (click)="close()"
                                    class="aw-button aw-button--outline"
                                    [class.aw-button--primary]="data.buttonMap.primary === 'OK'"
                                >
                                    OK
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    `,
    styles: `
        .ngS25ModalDialogBtn {
            display: flex;
            gap: 0.5em;
            padding-top: 0;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalDialogComponent extends ModalComponent<ModalDialogParams> implements OnInit {
    public static asDialog = true;

    initModal: boolean = false;

    close() {
        this.data.closeModal();
        return this.data.answer;
    }

    continue() {
        this.data.answer = ModalDialogParams.Answer.Yes;
        return this.close();
    }

    yes() {
        this.data.answer = ModalDialogParams.Answer.Yes;
        return this.close();
    }

    no() {
        this.data.answer = ModalDialogParams.Answer.No;
        return this.close();
    }

    cancel() {
        this.data.answer = ModalDialogParams.Answer.Cancel;
        return this.close();
    }

    ngOnInit() {
        const dialogParams = this.data as ModalDialogParams & { msg?: string };
        if (!dialogParams.message && dialogParams.msg) {
            dialogParams.message = dialogParams.msg;
        }
        this.initModal = true;
    }
}

export interface ModalDialogParams {
    answer: ModalDialogParams.Answer;
    message: string;
    showDontShowAgain?: boolean;
    dontShowAgain?: boolean;
    buttonMap: {
        hasYes?: NumericalBoolean;
        hasNo?: NumericalBoolean;
        hasCancel?: NumericalBoolean;
        hasContinue?: NumericalBoolean;
        hasOK?: NumericalBoolean;
        primary?: ModalDialogParams.ButtonType;
    };
}
export namespace ModalDialogParams {
    export const enum Answer {
        Cancel = -1,
        No = 0,
        Yes = 1,
    }
    export type ButtonType = "Yes" | "Continue" | "No" | "Cancel" | "OK";
}
